import React from 'react'
import { Link } from 'gatsby'
import styles from './DocumentationNav.module.css'
import classNames from 'classnames'

const DocumentationNav = ({ docs, current }) => {
  const nodes = docs
    .map((edge) => edge.node)
    .sort((a, b) => (a.frontmatter.title <= b.frontmatter.title ? -1 : 1))

  return (
    <div className={styles.root}>
      <h4>Docs</h4>
      {nodes.map((node) => {
        const linkClass = classNames(styles.link, {
          [styles.current]:
            current && current.frontmatter.slug === node.frontmatter.slug,
        })
        return (
          <div className={linkClass}>
            <Link to={`https://suggested.co${node.frontmatter.slug}`}>
              {node.frontmatter.title}
            </Link>
          </div>
        )
      })}
    </div>
  )
}

export default DocumentationNav
